import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ug',
  templateUrl: './ug.component.html',
  styleUrls: ['./ug.component.scss']
})
export class UgComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
